import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ConsultationModal from './ConsultationModal';

function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <footer className="bg-surface-dark py-14 text-white">
        <div className="container mx-auto px-4">
          <div className="grid gap-10 md:grid-cols-4">
            <div className="md:col-span-1">
              <h3 className="font-display text-2xl font-semibold">Sheryl Williams</h3>
              <p className="mt-1 text-sm uppercase tracking-[0.18em] text-primary-300">
                Hair Replacement
              </p>
              <p className="mt-4 text-white/65">
                Private consultations, custom systems, and ongoing care for natural-looking results.
              </p>
            </div>

            <div>
              <h3 className="mb-4 font-semibold">Explore</h3>
              <ul className="space-y-2 text-white/65">
                <li>
                  <Link to="/about" className="hover:text-white">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="hover:text-white">
                    Services
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="hover:text-white">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/careers" className="hover:text-white">
                    Careers
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="mb-4 font-semibold">Services</h3>
              <ul className="space-y-2 text-white/65">
                <li>
                  <Link to="/services/analysis" className="hover:text-white">
                    Consultation
                  </Link>
                </li>
                <li>
                  <Link to="/services/custom" className="hover:text-white">
                    Custom Hair Systems
                  </Link>
                </li>
                <li>
                  <Link to="/services/treatments" className="hover:text-white">
                    Fitting & Blending
                  </Link>
                </li>
                <li>
                  <Link to="/services/maintenance" className="hover:text-white">
                    Maintenance & Reattachment
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="mb-4 font-semibold">Get in touch</h3>
              <ul className="space-y-2 text-white/65">
                <li>247 East High Street, Pottstown, PA</li>
                <li>154 West Englewood Ave, Teaneck, NJ</li>
                <li>
                  <a href="tel:+12017267342" className="font-semibold text-white hover:text-primary-200">
                    (201) 726-7342
                  </a>
                </li>
                <li>
                  <a href="mailto:sheryl@sherylwilliams.com" className="hover:text-white">
                    sheryl@sherylwilliams.com
                  </a>
                </li>
              </ul>
              <button
                type="button"
                onClick={() => setIsModalOpen(true)}
                className="mt-6 rounded-full bg-primary-600 px-6 py-2.5 text-sm font-semibold text-white transition duration-300 hover:bg-primary-500"
              >
                Book Consultation
              </button>
            </div>
          </div>

          <div className="mt-12 border-t border-white/10 pt-8 text-center text-sm text-white/50">
            <p>
              &copy; {new Date().getFullYear()} Sheryl Williams Hair Replacement. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      <ConsultationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}

export default Footer;
